var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scp-lit" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "scp-lit-sources" },
          _vm._l(_vm.sources, function (source) {
            return _c(
              "div",
              { key: source.id, staticClass: "scp-lit-source-block" },
              [
                _c("div", { staticClass: "scp-lit-source-head" }, [
                  _c("span", { staticClass: "scp-lit-source-label" }, [
                    _vm._v(_vm._s(source.label)),
                  ]),
                ]),
                _vm._l(_vm.queries, function (row, index) {
                  return _c(
                    "div",
                    { key: row.id, staticClass: "scp-lit-query-row" },
                    [
                      _c("div", { staticClass: "scp-lit-query-meta" }, [
                        _c("span", { staticClass: "scp-lit-query-label" }, [
                          _vm._v(_vm._s(row.label || `Search ${index + 1}`)),
                        ]),
                        row.reason
                          ? _c("p", { staticClass: "scp-lit-query-reason" }, [
                              _vm._v(_vm._s(row.reason)),
                            ])
                          : _vm._e(),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: row.query,
                            expression: "row.query",
                          },
                        ],
                        staticClass: "scp-lit-source-input",
                        attrs: {
                          type: "text",
                          "aria-label":
                            (row.label || `Search ${index + 1}`) + " query",
                        },
                        domProps: { value: row.query },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(row, "query", $event.target.value)
                            },
                            _vm.emitQueryChange,
                          ],
                        },
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "scp-lit-source-open",
                          attrs: {
                            type: "button",
                            disabled: !row.query.trim(),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onOpen(source, row.query)
                            },
                          },
                        },
                        [_vm._v(" Open in " + _vm._s(source.label) + " ")]
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }